import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ProfileInfo } from '../gateway.model';
import { GateWayProfileActionTypes, GateWayProfileActions } from '../actions/gateway-profile.actions';

export interface GateWayProfileListState {
  Loaded: boolean;
  Loading: boolean;
  entities: ProfileInfo[];
}

export const initialProfileListState: GateWayProfileListState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export interface GateWayProfileInfoState {
  Loaded: boolean;
  Loading: boolean;
  entities: ProfileInfo;
}

export const initialProfileInfoState: GateWayProfileInfoState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export function profileListReducer(state = initialProfileListState, action: GateWayProfileActions): GateWayProfileListState {
  switch (action.type) {
    case GateWayProfileActionTypes.ReadProfileList:
      return {...state, Loaded: false, Loading: true};

    case GateWayProfileActionTypes.UpsertProfileList:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case GateWayProfileActionTypes.ReadProfileListFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

export function profileInfoReducer(state = initialProfileInfoState, action: GateWayProfileActions): GateWayProfileInfoState {
  switch (action.type) {
    case GateWayProfileActionTypes.ReadProfileInfo:
      return {...state, Loaded: false, Loading: true};

    case GateWayProfileActionTypes.UpsertProfileInfo:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case GateWayProfileActionTypes.ReadProfileInfoFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

export const getGateWayProfileListState = (state: GateWayProfileListState) => state;
export const getGateWayProfileInfoState = (state: GateWayProfileInfoState) => state;
